module.exports = __webpack_public_path__ + "img/public/SiteIcons/printer.png?321f3439";